import config from "configs/config";


export const getPaypalUrl = (paypalId: string) => {

    const environment = config.environment;
    if (environment === 'production') return `https://www.paypal.com/checkoutnow?token=${paypalId}`;
    return `https://www.sandbox.paypal.com/checkoutnow?token=${paypalId}`;
};
